<div class="main_container">
    <section>
        <article *ngIf="!isPageError">
            <div class="content">
                <div class="main-action-col">
                    <div style="padding-left: 15px; padding-right: 15px; margin-left: auto; margin-right: auto;">
                        <div class="row">
                            <div class="col-sm-5">
                                <h2 class="title">Site Overview</h2>
                            </div>
                            <div class="col-sm-7">
                                <div class="cam-pagination-listsImg">
                                    <div class="innerRightActions">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-3">
                    <div class="row m-0 row-custom">
                        <div class="col-12 col-md-6 col-sm-6 col-lg-4 col-xl-3 p-1 total-area" *ngIf="sitegraph">
                            <div class="chart-size p-2">
                                <h3>Sites Total Data</h3>
                                <!-- <app-chartjs [insightId]="sitegraph.insightId" [insightData]="sitegraph.insightData"
                                [configData]="sitegraph.configOptions">
                            </app-chartjs> -->
                                <canvas baseChart [data]="sitegraph.insightData.data" [colors]="chartColors"
                                    [options]="pieChartOptions" [labels]="sitegraph.insightData.labels"
                                    [chartType]="pieChartType"></canvas>
                                <div style="font-size: 10px;margin-top: 35px;">* 2-Installed, 4-Pre-Removal
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-sm-6 col-lg-4 col-xl-3 p-1 total-area">
                            <div class="chart-size p-2">
                                <h3>Sites Total Count</h3>
                                <div class="total-count">{{sitesTotalCount}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-sm-6 col-lg-4 col-xl-3 p-1 total-area" *ngIf="sitegraph1">
                            <div class="chart-size p-2">
                                <h3>Device Total Data</h3>
                                <!-- <app-chartjs class="chart_style" [insightId]="sitegraph1.insightId" [insightData]="sitegraph1.insightData"
                                [configData]="sitegraph1.configOptions">
                            </app-chartjs> -->
                                <canvas baseChart [data]="sitegraph1.insightData.data" [colors]="chartColors"
                                    [options]="pieChartOptions" [labels]="sitegraph1.insightData.labels"
                                    [chartType]="pieChartType"></canvas>
                                <div style="font-size: 10px;margin-top: 35px;">* 2-Installed, 4-Pre-Removal
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-sm-6 col-lg-4 col-xl-3 p-1 total-area">
                            <div class="chart-size p-2">
                                <h3> Device Total Count</h3>
                                <div class="total-count">{{totalDeviceCount}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-sm-6 col-lg-4 col-xl-3 p-1 total-area" *ngIf="fixedSites">
                            <div class="chart-size p-2">
                                <h3> Fixed Sites Data</h3>
                                <!-- <app-chartjs [insightId]="fixedSites.insightId"
                                [insightData]="fixedSites.insightData"
                                [configData]="fixedSites.configOptions">
                            </app-chartjs> -->
                                <canvas baseChart [data]="fixedSites.insightData.data" [colors]="chartColors"
                                    [options]="pieChartOptions" [labels]="fixedSites.insightData.labels"
                                    [chartType]="pieChartType"></canvas>
                                <div style="font-size: 10px;margin-top: 35px;">* 2-Installed, 4-Pre-Removal
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-sm-6 col-lg-4 col-xl-3 p-1 total-area">
                            <div class="chart-size p-2">
                                <h3> Fixed Sites Total Count</h3>
                                <div class="total-count">{{fixedCount}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-sm-6 col-lg-4 col-xl-3 p-1 total-area" *ngIf="mobileSites">
                            <div class="chart-size p-2">
                                <h3>Mobile Sites Data</h3>
                                <!-- <app-chartjs [insightId]="mobileSites.insightId" [insightData]="mobileSites.insightData"
                                [configData]="mobileSites.configOptions">
                            </app-chartjs> -->
                                <canvas baseChart [data]="mobileSites.insightData.data" [colors]="chartColors"
                                    [options]="pieChartOptions" [labels]="mobileSites.insightData.labels"
                                    [chartType]="pieChartType"></canvas>
                                <div style="font-size: 10px;margin-top: 35px;">* 2-Installed, 4-Pre-Removal
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-sm-6 col-lg-4 col-xl-3 p-1 total-area">
                            <div class="chart-size p-2">
                                <h3>Mobile Sites Total Count</h3>
                                <div class="total-count">{{mSitesCount}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-sm-6 col-lg-4 col-xl-3 p-1 total-area"
                            *ngIf="monitorCameraGraph">
                            <div class="chart-size p-2">
                                <h3>Camera Data</h3>
                                <!-- <app-chartjs [insightId]="monitorCameraGraph.insightId"
                                [insightData]="monitorCameraGraph.insightData"
                                [configData]="monitorCameraGraph.configOptions">
                            </app-chartjs> -->
                                <canvas baseChart [data]="monitorCameraGraph.insightData.data" [colors]="chartColors"
                                    [options]="pieChartOptions" [labels]="monitorCameraGraph.insightData.labels"
                                    [chartType]="pieChartType"></canvas>
                                <div style="font-size: 10px;margin-top: 35px;">* 2-Installed, 4-Pre-Removal
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-sm-6 col-lg-4 col-xl-3 p-1 total-area">
                            <div class="chart-size p-2">
                                <h3>Camera Total Count</h3>
                                <div class="total-count">{{totalCountCamera}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-sm-6 col-lg-4 col-xl-3 p-1 total-area"
                            *ngIf="monitorAlarmGraph">
                            <div class="chart-size p-2">
                                <h3> Alarms Data</h3>
                                <!-- <app-chartjs [insightId]="monitorAlarmGraph.insightId"
                                [insightData]="monitorAlarmGraph.insightData"
                                [configData]="monitorAlarmGraph.configOptions">
                            </app-chartjs> -->
                                <canvas baseChart [data]="monitorAlarmGraph.insightData.data" [colors]="chartColors"
                                    [options]="pieChartOptions" [labels]="monitorAlarmGraph.insightData.labels"
                                    [chartType]="pieChartType"></canvas>
                                <div style="font-size: 8px;margin-top: 35px;">* AXIS_HORN, IP_POWER_BOX, STROBE, X310,
                                    X410</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-sm-6 col-lg-4 col-xl-3 p-1 total-area">
                            <div class="chart-size p-2">
                                <h3> Alarms Total Count</h3>
                                <div class="total-count">{{totalCountAlarm}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-sm-6 col-lg-3 col-xl-3 p-1 total-area" *ngIf="alarmTypeGraph">
                            <div class="chart-size p-2">
                                <h3> Alarms Classification</h3>
                                <canvas baseChart [data]="alarmTypeGraph.insightData.data" [colors]="alarmTypeColors"
                                    [options]="pieChartOptions" [labels]="alarmTypeGraph.insightData.labels"
                                    [chartType]="pieChartType"></canvas>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-sm-6 col-lg-3 col-xl-3 p-1 total-area"
                            *ngIf="monitorOtherGraph">
                            <div class="chart-size p-2">
                                <h3> Other Devices Data</h3>
                                <!-- <app-chartjs [insightId]="monitorOtherGraph.insightId"
                                [insightData]="monitorOtherGraph.insightData"
                                [configData]="monitorOtherGraph.configOptions">
                            </app-chartjs> -->
                                <canvas baseChart [data]="monitorOtherGraph.insightData.data" [colors]="chartColors"
                                    [options]="pieChartOptions" [labels]="monitorOtherGraph.insightData.labels"
                                    [chartType]="pieChartType"></canvas>
                                <div style="font-size: 10px;margin-top: 35px;">* Access points, Client Bridges, NAS,
                                    Router, Switches</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-sm-6 col-lg-3 col-xl-3 p-1 total-area">
                            <div class="chart-size p-2">
                                <h3> Other Devices Total Count</h3>
                                <div class="total-count">{{totalCountOther}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-sm-6 col-lg-3 col-xl-3 p-1 total-area"
                            *ngIf="otherDevicestatus">
                            <div class="chart-size p-2">
                                <h3> Other Devices Status</h3>
                                <canvas baseChart [data]="otherDevicestatus.insightData.data"
                                    [colors]="chartColorsAgent" [options]="otherPieChartOptions"
                                    [labels]="otherDevicestatus.insightData.labels" [chartType]="pieChartType"></canvas>
                                <div style="font-size: 10px;margin-top: 30px; line-height: 1;">
                                    * NAS, Access points, Switches, Odroid, Router, Client Bridges</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-sm-6 col-lg-3 col-xl-3 p-1 total-area"
                            *ngIf="chartsDataAgent && chartsDataAgent">
                            <div class="chart-size p-2">
                                <h3 class="mb-4">Pro-Device Agent Versions </h3>
                                <canvas baseChart [data]="chartsDataAgent.agentVer" [colors]="chartColorsAgent"
                                    [options]="HidepieChartOptions" [labels]="chartsDataAgent.agentVerLabels"
                                    [chartType]="pieChartType">
                                </canvas>
                                <div class="details-down" style="padding-bottom: 10px"
                                    (click)="openDialog(chartsDataAgent.agentDetail.proDeviceAgentInfos)">
                                    (Details)
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-sm-6 col-lg-3 col-xl-3 p-1 total-area" *ngIf="monitoringType">
                            <div class="chart-size p-2">
                                <h3> Monitoring Type</h3>
                                <canvas baseChart [data]="monitoringType.insightData.data" [colors]="mTypeColos"
                                    [options]="pieChartOptions" [labels]="monitoringType.insightData.labels"
                                    [chartType]="pieChartType"></canvas>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-sm-6 col-lg-3 col-xl-3 p-1 total-area" *ngIf="installedCount">
                            <div class="chart-size p-2">
                                <h3> Site Wise Installation Count</h3>
                                <canvas baseChart [data]="installedCount.insightData.data" [colors]="mTypeColos"
                                    [options]="pieChartOptions" [labels]="installedCount.insightData.labels"
                                    [chartType]="pieChartType"></canvas>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-sm-6 col-lg-3 col-xl-3 p-1 total-area" *ngIf="camModels">
                            <div class="chart-size p-2">
                                <h3> Axis Camera Models</h3>
                                <canvas baseChart [data]="camModels.insightData.data" [options]="camModelChartOptions"
                                    [labels]="camModels.insightData.labels" [chartType]="pieChartType"></canvas>
                                    <div class="details-down cam-dialog" (click)="opencameraDialog()">
                                        (Details)
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-3 p-3">
                <app-x3-health-monitoring></app-x3-health-monitoring>
            </div>
        </article>
        <article *ngIf="isPageError" class="site-page-error">
            <p class="site-page-errorMsg">{{pageLoadMessage}}</p>
        </article>
    </section>
</div>